/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ContractAllocationForClaimResponseDto
 */
export interface ContractAllocationForClaimResponseDto {
    /**
     * 
     * @type {string}
     * @memberof ContractAllocationForClaimResponseDto
     */
    contractId: string;
    /**
     * 
     * @type {string}
     * @memberof ContractAllocationForClaimResponseDto
     */
    binderName: string;
    /**
     * 
     * @type {string}
     * @memberof ContractAllocationForClaimResponseDto
     */
    brokerName: string;
    /**
     * 
     * @type {string}
     * @memberof ContractAllocationForClaimResponseDto
     */
    reinsuredName: string;
    /**
     * 
     * @type {string}
     * @memberof ContractAllocationForClaimResponseDto
     */
    basisOfCover: ContractAllocationForClaimResponseDtoBasisOfCoverEnum;
    /**
     * 
     * @type {string}
     * @memberof ContractAllocationForClaimResponseDto
     */
    currency: string;
    /**
     * 
     * @type {string}
     * @memberof ContractAllocationForClaimResponseDto
     */
    limit: string;
    /**
     * 
     * @type {string}
     * @memberof ContractAllocationForClaimResponseDto
     */
    excess?: string;
    /**
     * 
     * @type {string}
     * @memberof ContractAllocationForClaimResponseDto
     */
    shareOfPremiumSigned: string;
    /**
     * 
     * @type {string}
     * @memberof ContractAllocationForClaimResponseDto
     */
    binderId: string;
}


/**
 * @export
 */
export const ContractAllocationForClaimResponseDtoBasisOfCoverEnum = {
    AnyOneEvent: 'Any One Event',
    AnyOneLocation: 'Any One Location',
    InTheAggregate: 'In the Aggregate'
} as const;
export type ContractAllocationForClaimResponseDtoBasisOfCoverEnum = typeof ContractAllocationForClaimResponseDtoBasisOfCoverEnum[keyof typeof ContractAllocationForClaimResponseDtoBasisOfCoverEnum];


/**
 * Check if a given object implements the ContractAllocationForClaimResponseDto interface.
 */
export function instanceOfContractAllocationForClaimResponseDto(value: object): value is ContractAllocationForClaimResponseDto {
    if (!('contractId' in value) || value['contractId'] === undefined) return false;
    if (!('binderName' in value) || value['binderName'] === undefined) return false;
    if (!('brokerName' in value) || value['brokerName'] === undefined) return false;
    if (!('reinsuredName' in value) || value['reinsuredName'] === undefined) return false;
    if (!('basisOfCover' in value) || value['basisOfCover'] === undefined) return false;
    if (!('currency' in value) || value['currency'] === undefined) return false;
    if (!('limit' in value) || value['limit'] === undefined) return false;
    if (!('shareOfPremiumSigned' in value) || value['shareOfPremiumSigned'] === undefined) return false;
    if (!('binderId' in value) || value['binderId'] === undefined) return false;
    return true;
}

export function ContractAllocationForClaimResponseDtoFromJSON(json: any): ContractAllocationForClaimResponseDto {
    return ContractAllocationForClaimResponseDtoFromJSONTyped(json, false);
}

export function ContractAllocationForClaimResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ContractAllocationForClaimResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'contractId': json['contractId'],
        'binderName': json['binderName'],
        'brokerName': json['brokerName'],
        'reinsuredName': json['reinsuredName'],
        'basisOfCover': json['basisOfCover'],
        'currency': json['currency'],
        'limit': json['limit'],
        'excess': json['excess'] == null ? undefined : json['excess'],
        'shareOfPremiumSigned': json['shareOfPremiumSigned'],
        'binderId': json['binderId'],
    };
}

export function ContractAllocationForClaimResponseDtoToJSON(json: any): ContractAllocationForClaimResponseDto {
    return ContractAllocationForClaimResponseDtoToJSONTyped(json, false);
}

export function ContractAllocationForClaimResponseDtoToJSONTyped(value?: ContractAllocationForClaimResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'contractId': value['contractId'],
        'binderName': value['binderName'],
        'brokerName': value['brokerName'],
        'reinsuredName': value['reinsuredName'],
        'basisOfCover': value['basisOfCover'],
        'currency': value['currency'],
        'limit': value['limit'],
        'excess': value['excess'],
        'shareOfPremiumSigned': value['shareOfPremiumSigned'],
        'binderId': value['binderId'],
    };
}

